import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Receipt } from "lucide-react";
import * as portalApi from "../../api/payroll/payrollPortalApi";
import PayslipBreakdown from "../../components/payroll/PayslipBreakdown";
import PaymentStatusBadge from "../../components/payroll/PaymentStatusBadge";
import { Card, CardContent, Alert, Skeleton, EmptyState } from "../../components/ui";
import { useToast } from "../../context/ToastContext";

const MONTHS = [
  "",
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export default function MyPayslipDetail() {
  const { id } = useParams();
  const [payslip, setPayslip] = useState(null);
  const [loading, setLoading] = useState(true);
  const toast = useToast();

  useEffect(() => {
    (async () => {
      try {
        const res = await portalApi.getMyPayslipById(id);
        setPayslip(res.data || res);
      } catch (err) {
        toast.error(err.response?.data?.message || "Failed to load");
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  if (loading) {
    return (
      <div className="mx-auto max-w-4xl space-y-6 p-4 sm:p-6">
        <div className="space-y-2">
          <Skeleton height={16} width={100} />
          <Skeleton height={32} width={220} />
        </div>
        <Card>
          <CardContent className="space-y-4 p-6">
            <Skeleton height={40} width="100%" />
            <Skeleton height={120} width="100%" />
            <Skeleton height={80} width="100%" />
          </CardContent>
        </Card>
      </div>
    );
  }

  if (!payslip) {
    return (
      <div className="mx-auto max-w-4xl p-4 sm:p-6">
        <Card>
          <EmptyState icon={Receipt} title="Payslip not found" />
        </Card>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-4xl space-y-6 p-4 sm:p-6">
      {/* Navigation & Header */}
      <div className="border-b border-neutral-200 dark:border-neutral-800 pb-4">
        <Link
          to="/staff-panel/my-payslips"
          className="mb-2 inline-flex items-center gap-1 text-sm font-semibold text-neutral-500 dark:text-neutral-400 transition-colors hover:text-primary-600"
        >
          <ArrowLeft className="h-3.5 w-3.5" aria-hidden="true" /> My Payslips
        </Link>
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <h1 className="text-xl font-semibold tracking-tight text-neutral-900 dark:text-neutral-100 sm:text-2xl">
            {MONTHS[payslip.month]} {payslip.year} Payslip
          </h1>
          <div className="shrink-0">
            <PaymentStatusBadge status={payslip.paymentStatus} />
          </div>
        </div>
      </div>

      {/* Main Breakdown Display */}
      <Card>
        <CardContent className="p-6">
          <PayslipBreakdown payslip={payslip} />
        </CardContent>
      </Card>
    </div>
  );
}